import { Colors, Services } from '@sigma-frontend-libs/commons'
import { MODERATION_VALUES } from '@sigma-legacy-libs/essentials/lib/constants'

import { globalErrorHandler, icons, request } from '@/utils'

import render from './render'

export default {
  name: 'Actions',

  props: {
    sending: {
      type: Object,
      default: () => {
        return {}
      }
    },

    filter: {
      type: Object,
      default: () => {
        return {}
      }
    },
    range: {
      type: Object,
      default: () => {
        return {}
      }
    },

    massive: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      showRejectMenu: false,

      providerId: undefined
    }
  },

  computed: {
    icon() {
      const result = {
        approved: {
          icon: icons.done,
          color: Colors.success
        },
        rejected: {
          icon: icons.close,
          color: Colors.error
        },
        rejectedRefound: {
          icon: icons.money_off_csred,
          color: Colors.error
        }
      }
      if (this.massive) {
        result.approved = {
          icon: icons.done_all,
          color: Colors.success
        }
        result.rejected = {
          icon: icons.remove_done,
          color: Colors.error
        }
      }

      return result
    },

    disabled() {
      return this.loading || this.massive && !this.filter.OwnerId
    }
  },

  methods: {
    async createTask(moderation, refund) {
      if (this.checkPermissions(`advanced.${Services.sendingsModeration}.create`)) {
        this.loading = true
        if (moderation === MODERATION_VALUES.rejected) {
          this.providerId = undefined
        }
        try {
          let sender
          let pattern
          let OwnerId
          if (this.massive) {
            sender = this.filter.sender
            pattern = this.filter.pattern
            OwnerId = this.filter.OwnerId
          } else {
            sender = this.sending.sender
            pattern = this.sending.text
            OwnerId = this.sending.OwnerId || this.filter.OwnerId
          }

          await request.create(Services.sendingsModeration, {
            body: {
              refund,
              range: this.range,
              sender,
              pattern,
              providerId: this.providerId,
              moderation: MODERATION_VALUES[moderation],
              OwnerId
            }
          })
          this.addSnackbar({
            text: this.getTranslate(`${Services.tasks}.snackbars.created`),
            type: 'success'
          })
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
          this.providerId = undefined
        }
      }
    }
  },

  render
}
